import React from 'react';
import { StyleSheet } from 'react-native';
import { DRNCardView, DRNTouchableWrapper } from '@traveloka/district-ui';
import R from 'common/res/R';

const styles = StyleSheet.create({
  cardWrapper: {
    padding: 0,
    marginBottom: R.spacing.xs,
  },
});

const TouchableCard = ({ style, onPress: handlePress, children }) => {
  const extraStyle =
    typeof style === 'object' ? { ...StyleSheet.flatten(style) } : style;

  return (
    <DRNCardView style={[styles.cardWrapper, extraStyle]}>
      <DRNTouchableWrapper onPress={handlePress}>
        {children}
      </DRNTouchableWrapper>
    </DRNCardView>
  );
};

export default TouchableCard;
